interface selectedStyleProps {
  targetKey: string;
  currrentKey: string;
}
export const selectedStyle = ({ targetKey, currrentKey }: selectedStyleProps) => {
  // return{ background: '#f1faff', color: '#009ef7' }
  if (targetKey === currrentKey) {
    return { backgroundColor: '#E3F2FD', borderRadius: '5px', color: '#009ef7' };
  }
  return { backgroundColor: 'white' };
};
